module.exports = __webpack_public_path__ + "static/media/jaybird-vista.52286c6f.jpg";